var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"container"}},[(_vm.value)?_c('i',{staticClass:"fa fa-spinner spin fa-3x text-white"}):_vm._e(),(!_vm.value)?_c('iframe',{ref:"pdf_iframe",attrs:{"id":"pdf_iframe","src":_vm.src}}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }